module.exports = __webpack_public_path__ + "static/media/4.755505ab.jpg";